import { Button } from "@carbon/react";

import { IOnboardingStepViewProps } from "../Onboarding";
import { Select, TextInput } from "../../../ui";
import { SectionHeader } from "../../../components";

export const View = (props) => {
  return (
    <div className="onboarding-section">
      <SectionHeader
        title="Let’s start with some basics."
        subtitle="We need you to complete your Business profile before you start receiving payments."
      />

      <h5 className="form-section--title font-ctm--bold">Business type</h5>

      <TextInput disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <div className="flex-container buttons-container">
        {!props.isActive ? null : (
          <Button
            className="switchapp-themed onboarding-submit--button"
            onClick={props.onSubmit}
          >
            Continue
          </Button>
        )}
      </div>
    </div>
  );
};
